import { AxiosRequestConfig } from 'axios'

import { ReviewsFilters } from '../api'

const buildReviewsParams = (filters: ReviewsFilters): Record<string, string | number> => {
  const params: Record<string, string | number> = {}
  if (filters.dateFrom) params.dateFrom = filters.dateFrom
  if (filters.dateTo) params.dateTo = filters.dateTo
  if (filters.storeId !== '' && filters.storeId != null) params.storeId = filters.storeId
  if (filters.minStars !== '' && filters.minStars != null) params.minStars = filters.minStars
  if (filters.maxStars !== '' && filters.maxStars != null) params.maxStars = filters.maxStars
  if (filters.source && filters.source !== 'all') params.source = filters.source
  if (filters.responded && filters.responded !== 'all') params.responded = filters.responded
  return params
}

const getReviewStats = (filters: ReviewsFilters): AxiosRequestConfig => ({
  url: '/reviews/stats',
  method: 'GET',
  params: buildReviewsParams(filters),
})

export { getReviewStats }
